"use client";

import Link from "next/link";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";

// Public support page: the support URL of Klap's ChatGPT app and Claude
// connector listings, so it must work signed out.
export default function SupportContent() {
  return (
    <div>
      <Header />
      <main className="prose mx-auto px-4 py-8">
        <h1>Support</h1>
        <p>
          We&apos;re here to help with your account, your shorts, exports,
          scheduling, billing, and Klap in ChatGPT and Claude.
        </p>

        <h2>Contact us</h2>
        <ul>
          <li>
            Email:{" "}
            <a className="text-violet-600" href="mailto:support@klap.app">
              support@klap.app
            </a>
          </li>
          <li>
            Live chat:{" "}
            <a
              className="text-violet-600 cursor-pointer"
              onClick={() => {
                // @ts-ignore
                window?.Intercom("show");
              }}
            >
              open the chat
            </a>{" "}
            (also available from the Klap app)
          </li>
        </ul>

        <h2>Klap in ChatGPT</h2>
        <p>
          To use Klap in ChatGPT, connect it from ChatGPT and sign in with your
          Klap account. You can disconnect it at any time from the apps section
          of ChatGPT&apos;s settings. Social accounts used for scheduling are
          connected in Klap, at{" "}
          <Link className="text-violet-600" href="/calendar">
            klap.app/calendar
          </Link>
          . What Klap exchanges with ChatGPT is described in our{" "}
          <Link className="text-violet-600" href="/privacy-policy#chatgpt">
            privacy policy
          </Link>
          .
        </p>

        <h2>Klap in Claude</h2>
        <p>
          To use Klap in Claude, add the Klap connector in Claude and sign in
          with your Klap account. You can disconnect it at any time from
          Customize → Connectors in Claude. The{" "}
          <Link className="text-violet-600" href="/claude">
            Klap for Claude guide
          </Link>{" "}
          explains how to connect it, what it can do and how to fix common
          issues. What Klap exchanges with Claude is described in our{" "}
          <Link className="text-violet-600" href="/privacy-policy#claude">
            privacy policy
          </Link>
          .
        </p>

        <h2>Report a security issue</h2>
        <p>
          If you find a security vulnerability in Klap, email{" "}
          <a
            className="text-violet-600"
            href="mailto:support@klap.app?subject=Security%20report"
          >
            support@klap.app
          </a>{" "}
          with &quot;Security report&quot; in the subject. Please give us time
          to fix it before sharing it publicly.
        </p>
      </main>
      <Footer />
    </div>
  );
}
